<div class="modal modal-full fade commentModal" id="offcanvas-inspect" [collapse]="isCollapsed" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="offcanvas-header">
                <button type="button" class="btn-close" (click)="cancelCaption()">
                    <img src="assets/icons/closeOutlined.svg" />
                </button>
            </div>

            <div class="offcanvas-body ui-dialog-fixed">
                <h2 class="background_title mb-4"> {{ 'CHECK.EDITOR.ADD_CAPTION' | translate}} </h2>

                <label class="input-floating">
                    <input #inputCaption type="text" class="form-input comment-input" [(ngModel)]="caption.statement"
                        placeholder="'CHECK.EDITOR.ENTER_CAPTION' | translate" />
                    <span>{{ 'CHECK.EDITOR.ENTER_CAPTION' | translate }}</span>
                </label>
            </div>

            <div class="offcanvas-footer">
                <button type="button" class="btn btn-cancel mr-4 d-flex align-items-center w-50" (click)="cancelCaption()">{{ 'CHECK.EDITOR.CANCEL' | translate }} </button>
                <button type="button" class="btn btn-confirm d-flex align-items-center w-50" [ngClass]="isDisabled()" (click)="saveCaption()"> {{ 'CHECK.EDITOR.SAVE_CHANGES' | translate }} </button>
            </div>
        </div>
    </div>
</div>
